module.exports = __webpack_public_path__ + "8c6ccf094f56d549da289b656fcd4440.png";